import { Tab, Tabs, styled } from "@mui/material";
export const TabsCustom = styled(Tabs)(() => ({
  "& .MuiTabs-indicator": {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "#0FBE7C",
    fontFamily: "PoppinsMedium",
  },
  "& .MuiTabs-indicatorSpan": {
    width: "100%",
    backgroundColor: "#808A98",
    fontFamily: "PoppinsMedium",
  },
  "&.Mui-selected": {
    backgroundColor: "transparent",
    fontFamily: "PoppinsMedium",
  },
  "& .MuiTab-root:focus": {
    outline: "none",
  },
}));
export const TabCustom = styled(Tab)(() => ({
  textTransform: "none",
  fontFamily: "PoppinsMedium",
  fontSize: "14px",
  marginRight: "1px",
  color: "#808A98",
  "&.Mui-selected": {
    color: "#0FBE7C",
    backgroundColor: "transparent",
    fontFamily: "PoppinsMedium",
  },
}));
